import LyNote from './src/main'

LyNote.install = function (Vue) {
    Vue.component(LyNote.name, LyNote)
}

export default LyNote